export default "__VITE_ASSET__CBtdi_u1__"